import { useFeatureFlagValue } from "@mirage/service-experimentation/useFeatureFlagValue";
import { convertFeatureValueToBool } from "@mirage/service-experimentation/util";

export const useIsActivityFeedEnabled = (): boolean => {
  const value = useFeatureFlagValue("dash_2024_06_13_activity_feed");
  return convertFeatureValueToBool(value);
};

export const useIsActivityFeedPeopleFilterEnabled = (): boolean => {
  const value = useFeatureFlagValue(
    "dash_2024_08_01_activity_feed_filter_people",
  );
  return convertFeatureValueToBool(value);
};

export const useIsActivityFeedOnlyMineFilterEnabled = (): boolean => {
  const value = useFeatureFlagValue(
    "dash_2024_08_01_activity_feed_filter_only_mine",
  );
  return convertFeatureValueToBool(value);
};
